/** @format */

import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import moment from 'moment';
import {
  faArrowRightArrowLeft,
  faArrowDownAZ,
  faArrowDownZA,
  faCircleInfo
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ArrowLeftOutlined, InfoCircleOutlined } from '@ant-design/icons';
import './aggiornamentiTable.scss';
import { useGetAggiornamenti } from 'services/GetAggiornamenti';
import { Table, Button, Tooltip, Modal } from 'antd';
import { useGetAggiornamentiDownload } from 'services/GetAggiornamentiDownload';
import { downloadFile } from '../../assets/extra/helpers';
import { useNavigate as useHistory } from 'react-router-dom';

const AggiornamentiTable = ({ defaultSkip, queryString }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const getAggiornamenti = useGetAggiornamenti();
  const getAggiornamentiDownload = useGetAggiornamentiDownload();
  const [tableData, setTableData] = useState();
  const [pageSize, setPageSize] = useState(9999);
  const [pageNum, setPageNum] = useState(1);

  useEffect(() => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');
    document.title = "Aggiornamenti - SITUAS";
  }, []);

  useEffect(async () => {
    await GetAggiornamenti(pageNum, pageSize);
  }, [pageNum, pageSize]);

  const infoIcon = (
    <InfoCircleOutlined aria-label={null} role={null} />
  );

  const GetAggiornamenti = async (num, size) => {
    let currDate = moment().format('YYYY-MM-DD');
    const aggData = await getAggiornamenti.execute(
      `?PageNum=${num}&PageSize=${size}&flagDiffusione=1&dateTime=${currDate}`
    );
    setTableData(aggData);
  };

  const columns = [
    {
      title: 'Evento',
      key: 'Evento',
      dataIndex: 'titolo',
      render: (titolo) => (
        <div style={{fontWeight:"600"}}>
          {titolo}
        </div>
      )
    },
    {
      title: 'Descrizione',
      key: 'Descrizione',
      dataIndex: 'testo',
      render: (testo, record) => (
        <div>
          <button
            className="btnReadMore"
            onClick={() => {
              Modal.info({
                title: record['titolo'],
                icon: infoIcon,
                width: 500,
                autoFocusButton: null,
                okButtonProps: {
                  style: { backgroundColor: '#426F80', border: 0, borderRadius: '5px' }
                },
                content: (
                  <div style={{ textAlign:"justify" }}>
                    {testo}
                  </div>
                ),
                onOk() {}
              });
            }}>
            <div className="textBtnTable" title={testo}>{testo}</div>
          </button>
        </div>
      ),
      ellipsis: {
        showTitle: false
      },
    },
    {
      title: 'Note',
      key: 'Note',
      dataIndex: 'sottotitolo'
    },
    {
      title: 'Data Pubblicazione',
      key: 'Data Pubblicazione',
      dataIndex: 'dataInizioValidita'
    }
    // {
    //   title: 'Data fine evento',
    //   key: 'Data fine evento',
    //   dataIndex: 'dataFineValidita'
    // },
    // {
    //   title: 'Data decorrenza evento',
    //   key: 'Data decorrenza evento',
    //   dataIndex: 'dataProvvedimento'
    // }
  ];
  const data = tableData?.body.map((aggiornamento, i) => {
    const provvedimento = aggiornamento.testoProvvedimento?.split(`\n`);
    return {
      key: i,
      titolo: aggiornamento.titolo,
      sottotitolo: aggiornamento.sottotitolo,
      testo: aggiornamento.testo,
      dataInizioValidita: moment(aggiornamento.dataInizioValidita).format('DD/MM/YYYY'),
      dataFineValidita: moment(aggiornamento.dataFineValidita).format('DD/MM/YYYY'),
      idProvvedimento: aggiornamento.idProvvedimento,
      testoProvvedimento: provvedimento ? provvedimento[1].replace('Testo:', '') : '',
      dataProvvedimento: provvedimento ? provvedimento[0].substring(24, 34) : ''
    };
  });

  const DownloadAggiornamenti = async () => {
    const file = await getAggiornamentiDownload.execute();
    downloadFile(file, file.filename ? file.filename + '.xlsx' : 'aggiornamenti.xlsx');
  };
  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <div>
        <button
          id="returnButton"
          aria-label='Torna indietro'
          onClick={() => {
            history(`/home`);
          }}>
          <ArrowLeftOutlined aria-label={null} />
          <span>Indietro</span>
        </button>
      </div>
      <div id="reportTitles">
        <div className="titleDownload">
          <h2>Aggiornamenti</h2>
          <div id="downloadBtnDiv">
            <Button
              loading={getAggiornamentiDownload.isLoading}
              icon={<FontAwesomeIcon aria-hidden="true" icon={faFileExcel} size="xl" />}
              aria-label="Scarica aggiornamenti in excel"
              onClick={() => {
                DownloadAggiornamenti();
              }}></Button>
          </div>
        </div>
        {/* <Table columns={label} /> */}
      </div>
      <Table id="tbl-aggiornamenti"
        style={{wordWrap:"break-word"}}
        columns={columns}
        dataSource={data}
      />
    </main>
  );
};

export default AggiornamentiTable;
